import type { FC } from 'react';
import { BiData, DefaultBiEvent } from '@wix/da-bi/pkg/events';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { PapiDeviation } from '@wix/da-papi-types';
import { pushOriginalSubmitModal } from '@wix/da-submit-shared/pkg/redux/actions/modal';
import OriginalsShopCard from '@wix/da-shared-react/pkg/ShopCard/OriginalsShopCard';
import { AllowedIndicators } from '@wix/da-shared-react/pkg/DeviationViews/Thumb/legos/DeviationThumbIndicators';
import SwipeSlider from '@wix/da-shared-react/pkg/SwipeSlider.v2';
import { ShopItemType } from '../../../../../../../types/shop';
import UploadMore from '../../../_partials/UploadMore';

interface Props {
  showAddItemCard?: boolean;
  deviations: PapiDeviation[];
}

const OriginalSliderMobile: FC<Props> = ({ showAddItemCard, deviations }) => {
  const allowedIndicators = AllowedIndicators.Discount;
  const { ref, dimensions: measuredContainer } = useMeasureElementCookie(
    undefined,
    {
      cookieDim: 'width',
    }
  );
  const dispatchPushOriginalSubmitModal = useAction(pushOriginalSubmitModal);

  const DEFAULT_CARD_WIDTH = 320;
  const DEFAULT_CARD_HEIGHT = 292;

  const cardWidthMobile = measuredContainer?.width ?? DEFAULT_CARD_WIDTH;

  return (
    <div ref={ref}>
      <SwipeSlider startSlide={showAddItemCard ? 1 : 0}>
        {showAddItemCard && (
          <UploadMore
            itemType={ShopItemType.ORIGINALS}
            height={DEFAULT_CARD_HEIGHT}
            biData={BiData<DefaultBiEvent>({
              evid: 2,
              click_info: 'create_original',
              sectionname: 'originals',
            })}
            onCreate={dispatchPushOriginalSubmitModal}
          />
        )}
        {deviations.map(deviation => (
          <OriginalsShopCard
            key={deviation.deviationId}
            width={cardWidthMobile}
            deviation={deviation}
            withAuthorDetails={false}
            allowedIndicators={allowedIndicators}
          />
        ))}
      </SwipeSlider>
    </div>
  );
};
OriginalSliderMobile.displayName = 'OriginalSliderMobile';

export default OriginalSliderMobile;
